module.exports = __webpack_public_path__ + "static/media/mobile-cover.7286f311.jpg";